<template>
    <div class="step-sect">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="step_list">
                        <div class="step_item">
                            <div class="success-item success">

                            </div>
                            <p class="min-min">Jämför</p>
                        </div>
                        <div class="step_item">
                            <div class="success-item">

                            </div>
                            <p class="min-min">Byt</p>
                        </div>
                        <div class="step_item">
                            <div class="success-item grey">

                            </div>
                            <p class="min-min">Klart</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StepSection"
    }
</script>
